import {ManagementTransformBase} from "../TranformBase";

import {
  TimezonesRecordModel,
  TimezonesListModel,
} from "@/api/models/actions/timezones";
import {TimeZone} from "@/api/services";

export class TimezonesTransform extends ManagementTransformBase<
  TimezonesRecordModel,
  false
> {
  public makeRecordModel(dto: TimeZone): TimezonesRecordModel {
    const model: TimezonesRecordModel = {
      abbreviation: dto.abbreviation,
      identifier: dto.identifier,
      offset: dto.offset,
    };

    return model;
  }

  public makeListModel(dto: TimeZone[]): TimezonesListModel {
    const model: TimezonesListModel = {
      records: dto?.map(item => this.makeRecordModel(item)),
    };

    return model;
  }
}

export const timezonesTransform = new TimezonesTransform();
